import { render, staticRenderFns } from "./KZMainPanel.vue?vue&type=template&id=bf401c8e&scoped=true&"
import script from "./KZMainPanel.vue?vue&type=script&lang=js&"
export * from "./KZMainPanel.vue?vue&type=script&lang=js&"
import style0 from "./KZMainPanel.vue?vue&type=style&index=0&id=bf401c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf401c8e",
  null
  
)

export default component.exports